<div class="row header-container">
    <div class="col-lg-3 col-sm-3 d-sm-block">
        <div class="row paddingTop3">
            <div class="col-lg-3 col-sm-3 d-sm-block">
                <div class="row">
                    <span class="dhl-type {{className}}">{{typeText}}</span>
                </div>
            </div>
            <div class="col-lg-9 col-sm-9 d-sm-block">
                <div class="row paddingTop7">
                    <span>{{statuswithspace}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-9 col-sm-9 d-sm-block">
        <div class="row paddingTop9">
            <span class="font-weight-bold">{{headerInfo.Year | translate}}  {{headerInfo.Make | translate}} {{headerInfo.Model | translate}}
                &nbsp;&nbsp; {{headerInfo.Vin}} &nbsp;
                <a style="cursor: pointer" class="icon-map-link" *ngIf="isPickedUp()" (click)="openTrackingModal()">
                    <span class="icon-map-pin"></span>{{this.configData.mapLink ? this.configData.mapLink.label: ''}}
                </a>
            </span>
        </div>
        <div class="row" *ngFor="let shipmnt of headerInfo.ShipmentIds">
            <span>{{configData.shipmentDetails.label1 | translate}}: {{shipmnt.shipmentID}}&nbsp;&nbsp;{{configData.shipmentDetails.label2 | translate}}:{{shipmnt.loadID}}</span>
        </div>
    </div>
    <mat-progress-spinner *ngIf="isLoading" class="progress-spinner" [diameter]="50" [color]="color" [mode]="mode">
</mat-progress-spinner>  
</div>

   


